import { render } from "./ImageViewer.vue?vue&type=template&id=b0b70ba4"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Gallery/ImageViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0b70ba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0b70ba4', __exports__)) {
    api.reload('b0b70ba4', __exports__)
  }
  
  module.hot.accept("./ImageViewer.vue?vue&type=template&id=b0b70ba4", () => {
    api.rerender('b0b70ba4', render)
  })

}


export default __exports__